import { ReactNode, useState } from 'react';
import { ReactComponent as Arrow } from '$icons/uncolored/arrow.svg';

const SPKAccordion = ({
  title,
  children,
  isOpen = false,
}: {
  title: string;
  children: ReactNode;
  isOpen?: boolean;
}) => {
  const [isOpenAccordion, setIsOpenAccordion] = useState(isOpen);

  const handleClickAccordion = () => {
    setIsOpenAccordion((prev) => !prev);
  };

  return (
    <div className="relative w-full">
      <button
        className="border w-full rounded-lg flex border-solid border-black/10 px-2 py-4 bg-white/70 text-sm font-bold items-center gap-2"
        type="button"
        onClick={handleClickAccordion}
      >
        <Arrow
          className={`w-4 h-4 fill-blue-600 ${
            isOpenAccordion ? 'rotate-0' : '-rotate-90'
          } transition-all`}
        />
        {title}
      </button>
      <div
        className={`rounded-lg transition-all duration-75 overflow-hidden bg-white px-4
            ${
              isOpenAccordion
                ? 'max-h-full border border-black/10 py-6'
                : 'max-h-0'
            }`}
      >
        {children}
      </div>
    </div>
  );
};

SPKAccordion.defaultProps = {
  isOpen: false,
};

export default SPKAccordion;
